import moment from 'moment';

export const mappedVisitorHistoryPageVisits = (
  pageVisits: { url: string; title: string; unixTs: number; privacyLevel: number }[],
  locale: string,
) => {
  return pageVisits.map(({ url, title, unixTs, privacyLevel }) => {
    return {
      url: url,
      title: title,
      privacyLevel,
      bottomRightInfo: moment(unixTs * 1000)
        .tz(locale)
        .format('L hh:mm A'),
      topRightInfo: '', //To Do - add duration here
    };
  });
};
